import { forwardRef, useImperativeHandle, useState } from 'react';
import * as moment from 'moment';
import { Button, FormControl, Glyphicon } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';

interface IProps {
    startingValue: string,
    onUpdate: (value: string) => void,
}

const UpdateDeadline = forwardRef((props: IProps, ref) => {
    const [currentValue, setCurrentValue] = useState(props.startingValue);

    // useImperativeHandle(ref, () => {
    //     return {
    //         getValue() {
    //             return currentValue;
    //         }
    //     };
    // });

    // onKeyDown(event) {
    //     const key = event.key;
  
    //      const isNavigationKey = key === KEY_LEFT ||
    //         key === KEY_RIGHT ||
    //         key === KEY_UP ||
    //         key === KEY_DOWN ||
    //         key === KEY_PAGE_DOWN ||
    //         key === KEY_PAGE_UP ||
    //         key === KEY_PAGE_HOME ||
    //         key === KEY_PAGE_END;
  
    //         if (isNavigationKey) {
    //             // this stops the grid from receiving the event and executing keyboard navigation
    //             event.stopPropagation();
    //         }
    //  }

    const handleChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        setCurrentValue(e.currentTarget.value);
    };

    const disableUpdate = props.startingValue == currentValue || (props.startingValue != currentValue && moment(currentValue).isValid() == false);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <MaskedInput
                className='form-control'
                style={{ height: 26, padding: '1px 5px', fontSize: 12, marginRight: 3 }}
                mask='11/11/1111'
                placeholder='mm/dd/yyyy'
                value={currentValue}
                onChange={handleChange}
            />
            <Button bsSize='xs' style={{ marginRight: 3 }} disabled={disableUpdate} onClick={() => props.onUpdate(currentValue)}><Glyphicon glyph='ok' /></Button>
            <Button bsSize='xs' disabled={props.startingValue == currentValue} onClick={() => setCurrentValue(props.startingValue)}><Glyphicon glyph='remove' /></Button>
        </div>
    );
});

export default UpdateDeadline;